
import React from 'react';

export type MapProps = {
  children?: React.ReactNode;
  showDetails?: boolean;
};

export const Bgis: React.FC<MapProps> = (props: Readonly<MapProps>) => {
  const { children, showDetails } = props;

  return <div className={`bgis${showDetails ? ' showDetails' : ''}`}>{children}</div>;
};
